import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/Modal'
import { useDeviceSize } from 'utils/hooks/useDeviceSize'
import Plain from './Plain'
import Edit from './Edit'

const DevPlanCard = ({
  actionSteps,
  date,
  title,
  planId,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast
}) => {
  const [editMode, setEditMode] = useState(false)
  const { isAtLeastSmallScreen } = useDeviceSize()
  const sortedSteps = [...actionSteps].sort(
    (a, b) => a.sortOrder - b.sortOrder
  )
  const toggleEditMode = () => setEditMode(!editMode)

  const editProps = {
    planId,
    actionSteps: sortedSteps,
    title,
    toggleEditMode
  }

  const plainProps = {
    ...editProps,
    date,
    onMoveUp,
    onMoveDown,
    isFirst,
    isLast
  }

  if (isAtLeastSmallScreen)
    return editMode ? (
      <Edit {...editProps} />
    ) : (
      <Plain {...plainProps} />
    )

  return (
    <>
      <Plain {...plainProps} />
      <Modal
        show={editMode}
        closeModal={toggleEditMode}
        mimicNative
        title="Edit Goal"
      >
        <Edit {...editProps} />
      </Modal>
    </>
  )
}

DevPlanCard.propTypes = {
  planId: PropTypes.number,
  actionSteps: PropTypes.array,
  title: PropTypes.string,
  date: PropTypes.string,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool
}

export default DevPlanCard
